import { SET_SELECTION, SET_SELECTED_OPTION, SET_IT_COMMENT } from "../actions/itServiceAction";

const initialState = {
    isSelectedIt: false,
    yesNoSelectedOption: null,
    comment: "", 
};

const selectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECTION:
            return { ...state, isSelectedIt: action.payload };
        
        case SET_SELECTED_OPTION:
            return { ...state, yesNoSelectedOption: action.payload };

        case SET_IT_COMMENT: 
            return { ...state, comment: action.payload };

        default:
            return state;
    }
};

export default selectionReducer;
